import type { RouteObject } from 'react-router';
import { DashboardPage } from './dashboard-page';
import { OnboardingPage } from './onboarding-page';

export const appRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  { path: 'primeiros-passos', element: <OnboardingPage /> },
];
